import Contact from "@/components/contact/Contact";

type Props = {};

export default function ContatoHome({}: Props) {
  return (
    <>
      <div className="rbt-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title text-center">
                <h2 className="title">Entre em contato</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Contact />
    </>
  );
}

